import React from "react";
import API from "@beardeddevops/react.api";
import {Types} from "components";
import {confirmAlert} from "react-confirm-alert";
import ObjectOverride from "components/ObjectOverride";

export default class TransactionObject extends ObjectOverride {
	// noinspection JSValidateTypes
	static propTypes = {
		...super.propTypes,
	};

	constructor(props, model) {
		super(props, model);
		this.state.search = null;
		this.state.modalAdd = false;
		this.state.modalLookup = false;
		this.state.transaction_entriess = [];
		this.handleProcess = this.handleProcess.bind(this);

		//For all transactions to have the new Binary ID
		if (this.state.pkey && this.state.pkey.toString() !== '0' && !this.state.binary_id) {
			let e = window.location.pathname;
			let path = e.split("/").slice(0, -1).join("/")
			setTimeout(() => {
				this.props.history.push(path);
			}, 500);
		}
	}

	componentDidMount() {
		super.componentDidMount();
		if (!this.props.id && this.props.initialDealer) {
			this.setNewObject('dealer')(this.props.initialDealer);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.state.search !== this.props.scannedCode) {
			this.setState({
				search: this.props.scannedCode
			}, this.shouldHandleScan);
		}

		if (this.state.pkey && this.state.pkey.toString() !== '0' && !this.state.binary_id) {
			let e = window.location.pathname; // '/this/is/a/path/to/a/file.html'
			let path = e.split("/").slice(0, -1).join("/")  //split to array & remove last element
			setTimeout(() => {
				this.props.history.push(path);
			}, 500);
		}
	}

	handleToggleModalAdd = () => {
		this.setState({modalAdd: true});
	}

	handleToggleModalLookup = () => {
		this.setState({modalLookup: true});
	}

	handleToggleModalCsv = () => {
		this.setState({modalCsv: true});
	}
	handleReportProductClose = () => {
			this.setState({
				modalAdd: false,
				modalLookup: false,
				modalCsv: false
			})

	}

	shouldHandleScan = async () => {
		//Don't process the code if another popup is open
		if (!this.state.modalAdd && !this.state.modalLookup && this.state.search && this.state.search.barcode) {
			this.setState({loading: true});

			let productModel = new API.BuildClass(Types.Products._name, API.RequestType.READ);
			productModel.object.pkey = this.state.search.barcode;
			productModel.object.id = this.state.search.prefix + '-' + this.state.search.barcode

			try {
				let product = await productModel.submit(null, API.RequestType.READ);
				if (!this.state.modalAdd && !this.state.modalLookup) {
					await this.addProducts([product]);
				}
			} catch (e) {
			}

			this.setState({loading: false});
		}
	}

	addProducts = async (products) => {
		// console.log('in add products', products, this);
		if (!this.state.pkey) {
			// console.log('in if', this);
			if (typeof this.state.transaction_entriess !== 'undefined' && Array.isArray(products)) {

				let entries = [...this.state.transaction_entriess, ...products.map(
					/**
					 * @param {Products_Object} product
					 * @returns {{product: *, product_binary_id: *, products: *}}
					 */
					product => {
						return {
							product: product.pkey,
							product_binary_id: product.binary_id,
							products: product
						}
					}
				)];
				this.setState({transaction_entriess: entries});
			}
		} else {
			// console.log('inside else add products', this)
			this.setState({loading: true});
			let entries = [];
			let binary_ids = [];
			if (typeof this.state.transaction_entriess !== 'undefined' && Array.isArray(products)) {
				let teModel = new API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ);
				teModel.object.product = products.map(
					/**
					 * @param {Products_Object} entry
					 * @returns {string}
					 */
					(entry) => entry.binary_id + '-' + entry.pkey
				);
				// noinspection JSValidateTypes
				teModel.parent = this.state.pkey;
				teModel.parent_binary_id = this.state.binary_id;
				// teModel.object.collection = this.state.pkey;
				// teModel.object.collection_binary_id = this.state.binary_id;
				try {
					let result = await teModel.submit(null, API.RequestType.CREATE);
					// noinspection JSUnresolvedVariable
					entries = result.pkeys;
					// noinspection JSUnresolvedVariable

					//frontend needs to update the product statuses
					//Backend already handles this but it is not being updated on frontend. That's what this loop does.
					if (this.props.baseUrl === '/dispositions') {
						products.map(product => {
							return product.status = 2; // set status to sold
						})
					}

					if (this.props.baseUrl === '/rentals') {
						products.map(product => {
							return product.status = 9; // set status to rented
						})
					}

					if (this.props.baseUrl === '/reservations') {
						products.map(product => {
							return product.status = 6; // set status to reservation
						})
					}

					if (this.props.baseUrl === '/destroys') {
						products.map(product => {
							return product.status = 7; // set status to destroyed
						})
					}
					if (this.props.baseUrl === '/acquisitions') {
						products.map(product => {
							return product.status = 1; // set status to in stock
						})
					}
					if (this.props.baseUrl === '/transfers') {
						products.map(product => {
							return product.status = 3; // set status to transferred
						})
					}
					if (this.props.baseUrl === '/losses') {
						products.map(product => {
							return product.status = 5; // set status to lost/stolen
						})
					}

					
					binary_ids = result.binary_ids;
					entries = [...this.state.transaction_entriess, ...products.map(product => {
						return {
							pkey: entries[product.pkey] || '',
							binary_id: binary_ids[product.pkey] || '',
							product: product.pkey,
							product_binary_id: product.binary_id,
							products: product
						}
					})];
					this.setState({transaction_entriess: entries});
				} catch(e) {
					console.error(e);
				}

			}
			this.setState({loading: false});
		}
		// console.log('state after', this)
	};

	/**
	 * @param {Products_Object} product
	 * @param {Transactions_Entries_Object} newEntry
	 * @param force
	 */
	updateProduct = (product, newEntry = null, force = false) => {
		if(!force) {
			if (typeof this.state.transaction_entriess !== 'undefined') {
				let entries = this.state.transaction_entriess.map(entry => {
					if (entry.product === product.pkey && entry.product_binary_id === product.binary_id) {
						entry.product = product.pkey;
						entry.product_binary_id = product.binary_id;
						entry.products = product;
						entry.pawn_redemption = newEntry.pawn_redemption;
					}
					return entry;
				});
				this.setState({transaction_entriess: entries});
			}
			if (typeof this.state.disposition_pending_itemss !== 'undefined') {
				let entries = this.state.disposition_pending_itemss.map(entry => {
					if (entry.product === product.pkey && entry.product_binary_id === product.binary_id) {
						entry.product = product.pkey;
						entry.product_binary_id = product.binary_id;
						entry.products = product;
						entry.pawn_redemption = newEntry.pawn_redemption;
					}
					return entry;
				});
				this.setState({disposition_pending_itemss: entries});
			}
			if( !newEntry ) {
				this.props.reloadPage();
			}
		} else{
			this.reloadIDs(this.props, 'object', true);
		}
	}

	deleteProduct = (entry, entry_binary_id, product, product_binary_id) => {
		if (!entry) {
			if (typeof this.state.transaction_entriess !== 'undefined') {
				let entries = this.state.transaction_entriess.filter(entry => entry.product !== product || entry.product_binary_id !== product_binary_id);
				this.setState({transaction_entriess: entries});
			}
			if (typeof this.state.disposition_pending_itemss !== 'undefined') {
				let entries = this.state.disposition_pending_itemss.filter(entry => entry.product !== product || entry.product_binary_id !== product_binary_id);
				this.setState({disposition_pending_itemss: entries});
			}
		} else {
			confirmAlert({
				title: 'Confirm Delete',
				message: 'Are you sure you want to remove this product?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							this.setState({loading: true});
							/** @type {RestfulObject} teModel */
							let teModel = null;
							if (typeof this.state.transaction_entriess !== 'undefined') {
								teModel = new API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ);
							}
							if (typeof this.state.disposition_pending_itemss !== 'undefined') {
								teModel = new API.BuildClass(Types.Dispositions_Pendings_Items._name, API.RequestType.READ);
							}
							if (!teModel) {
								this.setState({loading: false});
								return;
							}
							teModel.object.pkey = entry;
							teModel.object.binary_id = entry_binary_id;
							teModel.parent = this.state.pkey;
							teModel.parent_binary_id = this.state.binary_id;
							try {
								await teModel.submit(null, API.RequestType.DELETE);
								this.reloadIDs(this.props, 'object', true);
							} catch (e) {

							}
							this.setState({loading: false});
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		}
	};

	handleToggleProductModel = (forProduct) => {
		if (typeof this.state[forProduct] === 'undefined') {
			this.state[forProduct] = false;
		}
		return () => {
			this.setState({[forProduct]: true});
		};
	}
	handleReportModalClose = (forProduct) => () => {
		this.setState({[forProduct]: false});
	}

	/**
	 * Override to add custom validations in Objects
	 * STEP: Add Function
	 * STEP: Bind to THIS in constructor
	 *
	 * @param event
	 * @param requestOverride
	 * @returns {boolean|*}
	 */
	handleProcess(event, requestOverride) {
		let result = true;
		if (event && event.hasOwnProperty('bypassSelf') && typeof event.bypassSelf !== 'undefined' && event.bypassSelf) {
			if (!event.hasOwnProperty('target')) event = null;
			return result && super.handleProcess(event, requestOverride);
		}

		if (this.state.transaction_entriess === null || this.state.transaction_entriess.length === 0 && this.state.pkey === null) {
			API.Toast.warn('At least one product is required.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
			result = false;
		}

		//If either is false then fail
		return result && super.handleProcess(event, requestOverride);
	}

	async handleSubmit(e, suppressToast = false, suppressProcess = false) {
		if (typeof this.state.transaction_entriess !== 'undefined') {
			this.state.products = this.state.transaction_entriess.map(entry => entry.products.binary_id + '-' + entry.products.pkey);
		}
		if (typeof this.state.disposition_pending_itemss !== 'undefined') {
			this.state.products = this.state.disposition_pending_itemss.map(entry => entry.products.binary_id + '-' + entry.products.pkey);
			//Will warn on the handleProcess without setting transaction_entriess
			this.state.transaction_entriess = this.state.disposition_pending_itemss;
		}
		await super.handleSubmit(e, suppressToast, suppressProcess);
	};

	render() {
		return super.render();
	}
}
